import { Component, Prop, Vue } from 'vue-property-decorator';

import '../../../../../../../node_modules/tiny-slider/src/tiny-slider.scss';
import { TinySliderInstance, TinySliderSettings, tns } from 'tiny-slider';

// @ts-ignore
import GLightbox from 'glightbox';

interface Image {
  file: string;
  width: number;
  height: number;
  cls: string;
}

const template = `
<div class="slider" :class='mainClass'>
  <div class="slider__next" @click="nextSlide">
    <i class="img-right"></i>
  </div>
  <div class="slider__prev" @click="prevSlide">
    <i class="img-left"></i>
  </div>
  <div class="slider__tns" ref='slider-container'>
    <div class="slider__item" v-for="(img, k) in galleryItems" :key="k+img">
      <div
        class="slider__item-img"
        :class="img[0].cls"
        :style='{"background-image": "url(" + base + img[0].file + ")"}'
      ></div>
      <div
        class="slider__item-img "
        :class="img[1] ? img[1].cls : ''"
        :style='{"background-image": img[1] ? "url(" + base + img[1].file + ")" : "none"}'
      ></div>
    </div>
  </div>
</div>`;

@Component({
  template: template
})
export default class Slider extends Vue {
  @Prop({ default: 'slider--default' }) mainClass!: string;
  @Prop({ default: '' }) base!: string;
  @Prop({ default: () => [] }) imgs!: Array<Image>;
  @Prop({
    default: () => {
      return {};
    }
  }) sliderOpts!: TinySliderSettings;

  private slider?: TinySliderInstance = undefined;
  private gallery: any = null;
  private restartTimerId: any | null = null;

  get galleryItems(): Array<Array<Image>> {
    const list: Array<Array<Image>> = [];

    this.imgs.forEach((el, k, imgs) => {
      if (k % 2 == 0) {
        el.cls = el.width / el.height < 2 ? 'slider__item-img--h2' : '';

        if (imgs[k + 1]) {
          imgs[k + 1].cls = imgs[k + 1].width / imgs[k + 1].height < 2 ? 'slider__item-img--h2' : '';
        }

        list.push([
          el, imgs[k + 1]
        ]);
      }
    });

    return list;
  }

  mounted() {
    this.slider = tns(
      Object.assign(
        {
          items: 2,
          autoplayButton: false,
          autoplayButtonOutput: false,
          slideBy: 'page',
          autoWidth: false,
          autoplay: true,
          controls: false,
          speed: 3000,
          nav: false,
          // autoplayHoverPause: true,
          loop: true,
          autoplayTimeout: 6000,
          mouseDrag: false,
          swipeAngle: false,
          container: this.$refs['slider-container'],
          lazyload: true,
          responsive: {
            800: {
              items: 3,
              gutter: 10,
            },
            1100: {
              items: 4,
              gutter: 30,
            },
            1400: {
              items: 5
            },
          }
        },
        this.sliderOpts
      )
    );
  }

  nextSlide() {
    this.slider?.pause();
    this.slider?.goTo('next');
    this.startIn();
  }

  prevSlide() {
    this.slider?.pause();
    this.slider?.goTo('prev');
    this.startIn();
  }

  startIn() {
    if (this.restartTimerId) {
      clearTimeout(this.restartTimerId);
    }

    this.restartTimerId = setTimeout(() => {
      this.slider?.play();
    }, 20000);
  }

  openLightGallery(index: number) {
    const items = this.imgs.map((el) => {
      return {
        type: 'image',
        href: this.base + el,
      };
    });

    if (this.gallery == null) {
      this.gallery = GLightbox({
        elements: items
      });
    }

    this.gallery.openAt(index);
  }
}
